import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const CONTRACT_BEGIN = 'CONTRACT_BEGIN';
export const CONTRACT_ADD = 'CONTRACT_ADD';
export const CONTRACT_FAILURE = 'CONTRACT_FAILURE';


export function fetchContract() {
    return async dispatch => {
        dispatch(contractBegin());
        await ApiService.getContracts()
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idContract');
                    dispatch(contractAdd(normalized));
                    return normalized;
                },
                () => {
                    dispatch(contractError());
                }
            )
    };
}

export const contractBegin = () => ({
    type: CONTRACT_BEGIN,
});

export const contractAdd = data => ({
    type: CONTRACT_ADD,
    payload: { data }
});

export const contractError = () => ({
    type: CONTRACT_FAILURE,
});
